import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/shared/services/globals';
import { EventEmitterService } from '../../services/event-emitter.service';
import { Alert } from '../../models/alert.model';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DatePipe } from '@angular/common';
import { distinctUntilChanged, skip } from 'rxjs/operators';
import * as moment from 'moment';
import { PdaService } from '../../services/pda.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal/confirm/modal-confirm.component';
import { ModalActionComponent } from '../modal/modal-action/modal-action.component';
import { element } from 'protractor';

import {
  BsDatepickerDirective,
  BsLocaleService,
} from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { CausesService } from '../../services/causes.service';
import { LoadingService } from '../loading/loading.service';
@Component({
  selector: 'app-action-form',
  templateUrl: './action-form.component.html',
  styleUrls: ['./action-form.component.scss'],
})
export class ActionFormComponent implements OnInit {
  dataFormulario: FormGroup;
  members: any = [];
  resp: any = [];
  corresp: any = [];
  causas: any = [];
  causesDef: any = [];
  options: string[] = ['One', 'Two', 'Three'];
  format: string;
  clearBtn:string ="Borrar Fecha";
  loadingCauses=false;
  @Input() nro: any;
  @Input() disabled: boolean;
  @Input() data: any;
  @Input() fromPlansHistory: boolean;
  handleDatepickerEvents: boolean = false;
  @Output() emitData = new EventEmitter();
  @Output() public emitChangeSelected = new EventEmitter();
  checkedResponsables: any = [];
  checkedCorresponsables: any = [];
  checkedCausas: any = [];
  saving: boolean = false;
  fecha_notificacion;
  fecha_inicio;
  fecha_fin;
  fecha_ejecucion;
  causasSaved : boolean
  _subscription: any;
  // @ViewChild(BsDatepickerDirective, { static: false })
  // datepicker: BsDatepickerDirective;

  // @HostListener('document:mousewheel', ['$event'])
  // onDocumentMousewheelEvent(event) {
  //   console.log(this.datepicker);

  //   this.datepicker.hide();
  // }
  constructor(
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private globals: GlobalsService,
    private emit: EventEmitterService,
    private dp: DatePipe,
    private pda: PdaService,
    private el: ElementRef,
    private localeService: BsLocaleService,
    private causes: CausesService,    
    private emitService: EventEmitterService,
    private loadingService:LoadingService

  ) {}
  validate(event) {
    let e = event;
    if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
    // Allow: Ctrl+A
    (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+C
    (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+V
    (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+X
    (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    
    }
  }
  ngOnInit(): void {
    this.translate.currentLang == 'es'
      ? (this.format = 'DD/MM/YYYY')
      : (this.format = 'MM/DD/YYYY');
    this.translate.currentLang == 'es'
      ? this.applyLocale('es')
      : this.applyLocale('en');
    this.translate.currentLang == 'es'
      ? this.clearBtn="Borrar fecha"
      : this.clearBtn="Clear date"

      this.dataFormulario = this.fb.group({
        tarea: [
          { value:'', disabled: this.disabled },
          [
            Validators.required,
            Validators.maxLength(255),
            Validators.pattern('^[a-zA-Z0-9-_ +&()=;^.,@%#${}ñÑáéíóúÁÉÍÓÚ]+$'),
          ],
        ],
        causas: [
          { value: '', disabled: this.disabled }
        ],
        responsable: [
          {
            value: '',
            disabled: this.disabled,
          },
          Validators.required,
        ],
        corresponsable: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        prioridad: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        recursos: [
          { value:  '', disabled: this.disabled },
        ],
        materiales: [
          { value:  '', disabled: this.disabled },
        ],
        servicios: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        costos: [
          { value:'', disabled: this.disabled },
        ],
        fecha_notificacion: [
          {
            value:  '',
            disabled: this.disabled,
          },
        ],
        fecha_inicio: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        fecha_fin: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        fecha_ejecucion: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        fecha_validacion: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        cerrada: [
          {
            value: '',
            disabled: this.disabled,
          },
        ],
        en_ejecucion: [''],
        notas: [{ value: '', disabled: this.disabled }],
        saved: [false],
        id: [''],
        accion_padre_id: [''],
      });
      
    
   this.dataFormulario.get('en_ejecucion').disable()
      
     
   
  }
 
  ngAfterViewInit(): void {
    
  }
  applyLocale(leng) {
    this.localeService.use(leng);
  }
  /**
   * @name openModal
   * @author Daniel Ramirez
   * @description se abre el modal de seleccion de causas,responsables y corresponsables segun sea necesario
   */
  openModal(from) {
    if(from === 'causas'){
      this.loadingCauses = true;

      this.emitService.clickSave('causas');
      this._subscription = this.emitService.savedData$.subscribe((res) => {
        if(res =='data' || res =='no data'){
          this.getGralCauses(from)         

        }
      });
    }else{
      this.openSaved(from)
    }
  }
  openSaved(from){
    const modalRef = this.modalService.open(ModalActionComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'lg',
      backdrop: 'static', 
      keyboard: false
    });
    modalRef.componentInstance.from = from;
    modalRef.componentInstance.members = this.members;
    modalRef.componentInstance.causesDef = this.causesDef;
    modalRef.componentInstance.checkedMembers =
      from == 'responsable'
        ? this.checkedResponsables
        : from == 'corresponsable'
        ? this.checkedCorresponsables
        : this.checkedCausas;
        if (this._subscription) {
          this._subscription.unsubscribe();
        }
        

    modalRef.componentInstance.clickClose.subscribe((res) => {
      if (from == 'responsable') {
        this.resp=[]
        this.checkedResponsables = [];
        // console.log('RESP', res);
        let names = [];
        res.forEach((element) => {
          names.push(element.name);
          this.resp.push({
            usuario_id: element.id,
            tipo: 1,
            nombre_responsable: element.name,
          });
          this.checkedResponsables.push(element);
        });

        // console.log(names, this.resp);
        this.dataFormulario.get('responsable').patchValue(names.join(', '));
        this.emitData.emit(true);
      }
      if (from == 'corresponsable') {
        // console.log('CORRES', res);
        let names = [];
        this.corresp=[]
        this.checkedCorresponsables = [];
        res.forEach((element) => {
          names.push(element.name);
          if (element.id) {
            this.corresp.push({
              usuario_id: element.id,
              tipo: 2,
              nombre_responsable: element.name,
            });
            this.checkedCorresponsables.push({
              id: element.id,
              name: element.name,
              select: true,
            });
          } else {
            this.checkedCorresponsables.push({
              id: null,
              name: element.name,
              select: false,
            });
            this.corresp.push({
              tipo: 2,
              nombre_responsable: element.name,
            });
          }
        });
        // console.log(names, this.resp);
        this.dataFormulario.get('corresponsable').patchValue(names.join(', '));
        this.emitData.emit(true);
      }
      if (from == 'causas') {
        this.causas = [];
        this.checkedCausas=[]
        let names = [];
        res.forEach((element) => {
          names.push(element.name);
          this.causas.push({ causa: element.name, causa_general_id:element.id?element.id:null });
          this.checkedCausas.push({ name: element.name, id: element.id, select: element.id?true:false });
        });
        this.dataFormulario.get('causas').patchValue(names.join(', '));
        this.emitData.emit(true);
        this.saveAction(true)
      }
      let all_resp = this.resp.concat(this.corresp);
      let result2 = all_resp.reduce((unique, o) => {
        if (
          !unique.some(
            (obj) =>
              obj.nombre_responsable === o.nombre_responsable &&
              obj.tipo === o.tipo
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.resp = result2;
      // console.log('uniques', this.resp);
    });
  }
  formatDates(x): void {
    
    
    if (x.fecha_inicio) {
      x.fecha_inicio = moment(x.fecha_inicio, 'DD-MM-YYYY').format(this.format);
    }
    if (x.fecha_notificacion) {
      x.fecha_notificacion = moment(x.fecha_notificacion, 'DD-MM-YYYY').format(this.format);
    }
    if (x.fecha_fin) {
      x.fecha_fin_utc = x.fecha_fin;

      x.fecha_fin = moment(x.fecha_fin, 'DD-MM-YYYY').format(this.format);
     
    }
    if (x.fecha_ejecucion) {
      x.fecha_ejecucion_utc = x.fecha_ejecucion;
      x.fecha_ejecucion = moment(x.fecha_ejecucion, 'DD-MM-YYYY').format(this.format);
     
    }
    if (x.fecha_validacion) {
      x.fecha_validacion = moment(x.fecha_validacion, 'DD-MM-YYYY').format(this.format);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.members = [];
    // console.log('members', this.members);
    // console.log('disabled', this.disabled);

    if (this.data) {
      if (this.data.selected) {
        // console.log('selected', this.data.selected);
        //  this.loadingCauses = true;
        // this.emitService.clickSave('causas')
        // this.emitService.savedData.subscribe(res=>{
        //   this.getGralCauses()
        // })
        // this.getGralCauses()
        if (this.data.selected.integrantes.length) {
          for (let i = 0; i < this.data.selected.integrantes.length; i++) {
            this.members.push({
              name: this.data.selected.integrantes[i].usuario_organizacion
                .usuario.name,
              id: this.data.selected.integrantes[i].usuario_organizacion.usuario
                .id,
            });
          }
        }
      }
      if (this.data.action) {
      
        this.pda.getSingleAction(this.data.selected.id,this.data.action.id).subscribe((res:any)=>{
          this.formatDates(res.data)
          this.createForm(res.data)     

        })
        // this.createForm(this.data.action)
      }
    }
    // console.log('members', this.members);
  }
  /**
   * @name changesClose
   * @author Daniel Ramirez
   * @description se verifica el radio button, si esta en positivo se envia la accion al historico
   */
  changesClose(event) {
    // console.log('action cahnges', this.dataFormulario.value);
    // console.log(event);

    if (event.target.value == 1 && this.dataFormulario.get('saved').value) {
      const modalRef = this.modalService.open(ModalConfirmComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      });
      modalRef.componentInstance.title = 'action_historic';
      modalRef.componentInstance.from = 'action_historic';
      let body = { accion_pda_id: [this.dataFormulario.get('id').value] };
      // console.log(body);

      modalRef.componentInstance.clickClose.subscribe((resp: any) => {
        this.pda.sendActionToHistoric(this.data.selected.id, body).subscribe(
          (resp) => {

            this.emitChangeSelected.emit(this.data.selected.id);
            Alert.buildSuccessAlert(
              this.translate.instant(
                'action_plan.plan_development.sent_historic'
              )
            );
          },
          (err) => {
            console.log(err);

            Alert.buildErrorAlert(
              this.translate.instant(
                'action_plan.plan_development.error_historic'
              )
            );
          }
        );
      });
      modalRef.componentInstance.clickDismiss.subscribe((resp: any) => {
        this.dataFormulario.get('cerrada').patchValue('0');
      });
    } else {
      // console.log('nothing');
    }
  }
  datechanges(from) {
    console.log(    this.dataFormulario.value
      );
    if (this.handleDatepickerEvents) {
      this.emitData.emit(this.dataFormulario.value);
      if(from==='fecha_fin'){
        if(this.dataFormulario.get('fecha_fin').value !==''){
          this.dataFormulario.get('en_ejecucion').enable()
        }
      }
    }
    
  }
  editCheck(){
    this.emitData.emit(this.dataFormulario.value);
  }
  edit() {
    this.emitData.emit(true);
  }
  getOptionText(option) {

    return option.name ? option.name : null;
  }
  getGralCauses(from?): void {
    this.causes.getCausasGenerales(this.data.selected.id).subscribe(
      (res: any) => {
        this.causesDef = res.data.filter(x=>x.elegido==1);
        this.loadingCauses = false;
        if(from==='causas'){
        // console.log('causas',res);
         this.openSaved(from)
        }
      },
      (err) => {
        console.log('ERRROR CAUSAS GRALES');
        this.loadingCauses = false;
        this.openSaved(from)
      }
    );
  }
  /**
   * @name createForm
   * @author Daniel Ramirez
   * @description se crea el formulario desde 0, o se llenan los campos si es una accion existente
   */
  createForm(data) {
    this.fecha_notificacion = data.fecha_notificacion
      ?  moment(data.fecha_notificacion, this.format).toDate()
      : null;
    this.fecha_inicio = data.fecha_inicio ?  moment(data.fecha_inicio, this.format).toDate() : null;
    this.fecha_fin = data.fecha_fin ?  moment(data.fecha_fin, this.format).toDate() : null;
    this.fecha_ejecucion = data.fecha_ejecucion
      ?  moment(data.fecha_ejecucion, this.format).toDate()
      : null;
   
    let causas = [];
    let resp = [];
    let corresp = [];
    this.checkedResponsables = [];
    this.checkedCorresponsables = [];
    this.checkedCausas = [];
    if (data.causa_pda.length) {
      data.causa_pda.forEach((element) => {
        causas.push(element.causa);
        this.causas.push({ causa: element.causa, causa_general_id: element.causa_general ? element.causa_general.id : null});
        if(element.causa_general){
          this.checkedCausas.push({ name: element.causa, id: element.causa_general.id, select: true });

        }else{
          this.checkedCausas.push({ name: element.causa, id: '', select: false });
        }
        
      });
      
    }
    if (data.responsable.length) {
      data.responsable.forEach((element) => {
        if (element.tipo == 1) {
          this.checkedResponsables.push({
            id: element.usuario_organizacion.usuario.id,
            name: element.usuario_organizacion.usuario.name,
          });
          resp.push(element.usuario_organizacion.usuario.name);
          this.resp.push({
            usuario_id: element.usuario_organizacion.usuario.id,
            tipo: 1,
            nombre_responsable: element.usuario_organizacion.usuario.name,
          });
        } else {
          if (element.usuario_organizacion) {
            this.checkedCorresponsables.push({
              id: element.usuario_organizacion.usuario.id,
              name: element.usuario_organizacion.usuario.name,
              select: true,
            });
            this.resp.push({
              usuario_id: element.usuario_organizacion.usuario.id,
              tipo: 2,
              nombre_responsable: element.usuario_organizacion.usuario.name,
            });
          } else {
            this.checkedCorresponsables.push({
              id: null,
              name: element.nombre_responsable,
              select: false,
            });
            this.resp.push({
              tipo: 2,
              nombre_responsable: element.nombre_responsable,
            });
          }
          corresp.push(
            element.usuario_organizacion
              ? element.usuario_organizacion.usuario.name
              : element.nombre_responsable
          );
        }
      });
    }
    this.handleDatepickerEvents = true;
    this.dataFormulario.patchValue({
      tarea:data.tarea ? data.tarea : '',
      causas:causas ? causas.join(', ') : '',
      responsable:resp ? resp.join(', ') : '',
      corresponsable:corresp ? corresp.join(', ') : '',
      prioridad:data.prioridad ? data.prioridad : '',
      recursos:data.recursos ? data.recursos : '',
      materiales:data.recursos ? data.recursos : '',
      servicios:data.servicios ? data.servicios : '',
      costos:data.costos ? data.costos : '', 
      fecha_notificacion:data.fecha_notificacion ? data.fecha_notificacion : '',
      fecha_inicio: data.fecha_inicio ? data.fecha_inicio : '',
      fecha_fin: data.fecha_fin ? data.fecha_fin : '',
      fecha_ejecucion: data.fecha_ejecucion ? data.fecha_ejecucion : '',
      fecha_validacion: data.fecha_validacion ? data.fecha_validacion : '',
      cerrada: data.cerrada ? data.cerrada : '2',
      en_ejecucion: data.en_ejecucion ? data.en_ejecucion : '',
      notas: data.notas ? data.notas : '',
      saved: resp.length ? true : false,
      id: data.id ? data.id : '',
      accion_padre_id:data.accion_padre ? data.accion_padre : '',
    })
   

    if(data.fecha_fin){
      this.dataFormulario.get('en_ejecucion').enable()
    }
    if(this.disabled){
      this.dataFormulario.disable()
    }
    this.dataFormulario.updateValueAndValidity()
  } 
  /**
   * @name saveAction
   * @author Daniel Ramirez
   * @description se hace un llamado al servicio para guardar los detalles de la accion
   */
  saveAction(modal?) {
    let resp = this.resp.reduce((unique, o) => {
      if (
        !unique.some(
          (obj) =>
            obj.nombre_responsable === o.nombre_responsable &&
            obj.tipo === o.tipo
        )
      ) {
        unique.push(o);
      }
      return unique;
    }, []);
    let body_put;
    body_put = {
      tarea: this.dataFormulario.get('tarea').value,
      prioridad: this.dataFormulario.get('prioridad').value,
      recursos: this.dataFormulario.get('materiales').value,
      servicios: this.dataFormulario.get('servicios').value,
      costos: this.dataFormulario.get('costos').value,
      fecha_notificacion: this.dataFormulario.get('fecha_notificacion').value
        ? moment(
            this.dataFormulario.get('fecha_notificacion').value,
            this.format
          ).format('YYYY-MM-DD 12:00:00')
        : null,
      fecha_inicio: this.dataFormulario.get('fecha_inicio').value
        ? moment(
            this.dataFormulario.get('fecha_inicio').value,
            this.format
          ).format('YYYY-MM-DD 12:00:00')
        : null,
      fecha_fin: this.dataFormulario.get('fecha_fin').value
        ? moment(
            this.dataFormulario.get('fecha_fin').value,
            this.format
          ).format('YYYY-MM-DD 12:00:00')
        : null,
      fecha_ejecucion: this.dataFormulario.get('fecha_ejecucion').value
        ? moment(
            this.dataFormulario.get('fecha_ejecucion').value,
            this.format
          ).format('YYYY-MM-DD 12:00:00')
        : null,
      fecha_validacion: this.dataFormulario.get('fecha_validacion').value
        ? moment(
            this.dataFormulario.get('fecha_validacion').value,
           this.format
          ).format('YYYY-MM-DD 12:00:00')
        : null,
      cerrada: this.dataFormulario.get('cerrada').value,
      en_ejecucion: this.dataFormulario.get('en_ejecucion').value,
      notas: this.dataFormulario.get('notas').value,
      causas: this.causas,
      responsables: resp,
    };
    if (this.dataFormulario.get('accion_padre_id').value) {
      body_put.accion_padre_id = this.dataFormulario.get(
        'accion_padre_id'
      ).value;
    }
    // console.log('ENVIADO', body_put);

    if (this.dataFormulario.get('cerrada').value == 1) {
      const modalRef = this.modalService.open(ModalConfirmComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      });
      modalRef.componentInstance.title = 'action_historic';
      modalRef.componentInstance.from = 'action_historic';

      modalRef.componentInstance.clickClose.subscribe((resp: any) => {
        this.saving = true;
        this.pda
          .createAction(
            this.data.selected.id,
            body_put,
            this.dataFormulario.get('id').value
          )
          .subscribe(
            (res) => {
              let body = {
                accion_pda_id: [this.dataFormulario.get('id').value],
              };
              this.pda
                .sendActionToHistoric(this.data.selected.id, body)
                .subscribe(
                  (resp) => {
                    Alert.buildSuccessAlert(
                      this.translate.instant(
                        'action_plan.plan_development.sent_historic'
                      )
                    );
                  },
                  (err) => {
                    console.log(err);

                    Alert.buildErrorAlert(
                      this.translate.instant(
                        'action_plan.plan_development.error_historic'
                      )
                    );
                  }
                );
              this.saving = false;
              Alert.buildSuccessAlert(
                this.translate.instant('action_plan.plan_development.modified')
              );
              this.dataFormulario.get('saved').patchValue(true);
              this.emitChangeSelected.emit(this.data.selected.id);
            },
            (err) => {
              console.log(err);
              this.saving = false;
              Alert.buildErrorAlert(
                this.translate.instant(
                  'action_plan.plan_development.error_create'
                )
              );
            }
          );
      });
      modalRef.componentInstance.clickDismiss.subscribe((resp: any) => {});
    } else {
      if (this.dataFormulario.valid) {
        console.log("BODY ACTIONS", body_put);
        
        this.saving = true;
        this.loadingService.show();
        this.pda
          .createAction(
            this.data.selected.id,
            body_put,
            this.dataFormulario.get('id').value
          )
          .subscribe(
            (res:any) => {

              this.saving = false;
              this.loadingService.hide();

              if(!modal){
                Alert.buildSuccessAlert(
                  this.translate.instant('action_plan.plan_development.modified')
                );
                this.dataFormulario.get('saved').patchValue(true);
                this.emitChangeSelected.emit(this.data.selected.id);
              }
           
            },
            (err) => {
              console.log(err);
              this.saving = false;
              this.loadingService.hide();
              Alert.buildErrorAlert(
                this.translate.instant(
                  'action_plan.plan_development.error_create'
                )
              );
            }
          );
      } else {
        // console.log(this.dataFormulario.value);
        this.alert();
      }
    }
  }
  /**
   * @name alert
   * @author Daniel Ramirez
   * @description mensajes de alerta del formulario
   */
  alert() {
    Alert.buildErrorAlert(
      this.translate.instant('action_plan.plan_development.error_fields')
    );

    this.validateAllFormFields(this.dataFormulario);
  }
  /**
   * @name validateAllFormFields
   * @author Daniel Ramirez
   * @description se recorre el formulario en busca de errores de validacion
   */
  validateAllFormFields(formGroup: FormGroup) {
    // console.log('entro');
    // console.log(this.dataFormulario.value);
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        setTimeout((x) => control.markAsTouched({ onlySelf: true }));
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    for (const key of Object.keys(this.dataFormulario.controls)) {
      if (this.dataFormulario.controls[key].invalid) {
        this.dataFormulario.controls[key].markAsTouched();
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );
        setTimeout((x) => invalidControl.focus());

        break;
      }
    }
  }
}
